<template>
  <div v-if="showPage403" class="animated fadeIn content-holder"> 
    <Page403></Page403>
  </div>
  <div v-else class="animated fadeIn content-holder">
    <b-card>
      <b-card-header class="custom-header">
        <div>
          <i class="icon-settings mr-1"></i>
          {{ formName }}
        </div>
        <b-button variant="primary" :disabled="!permission.capabilities.Create" @click="openNew()">
          <i class="fa fa-plus"></i> New
        </b-button>
      </b-card-header>
      <b-card-body v-if="isLoading">
        <spinner></spinner>
      </b-card-body>
      <b-card-body v-else>
        <v-client-table
          id="formListTable"
          :data="data"
          :columns="columns"
          :options="options"
          :theme="theme"
        >
          <div slot="action" slot-scope="props">
            <b-button-group size="sm">
              <b-button v-b-tooltip.hover title="Edit" :disabled="!permission.capabilities.Edit" @click="openEditPage(props.row.id)">
                <i class="fa fa-edit"></i>
              </b-button>
              <b-button v-b-tooltip.hover title="Preview" @click="openPreview(props.row.id)">
                <i class="fa fa-camera-retro"></i>
              </b-button>
              <b-button v-b-tooltip.hover title="Change History" @click="openHistory(props.row.id)">
                <i class="fa fa-list"></i>
              </b-button>
              <b-button v-b-tooltip.hover title="Results" @click="openResults(props.row.id)">
                <i class="fa fa-database"></i>
              </b-button>
              <b-button
                v-b-tooltip.hover
                title="Delete"
                @click="openDeleteModal(props.row.id)"
                :disabled="!permission.capabilities.Delete"
                variant="danger"
              >
                <i class="fa fa-trash"></i>
              </b-button>
            </b-button-group>
          </div>
        </v-client-table>
      </b-card-body>
    </b-card>
    <DeleteConfirmModal 
      v-bind:modalTitle="deleteModal.modalTitle"
      v-bind:modalMsg="deleteModal.modalMsg"
      v-bind:loginUserRoleName="deleteModal.loginUserRoleName"
      v-on:toggle="getDeleteAction($event)" 
      ref="deleteConfirmModal"
    />
    <InfoModal ref="infoModal"></InfoModal>
  </div>
</template>

<script>
import Vue from "vue";
import miniToastr from "mini-toastr";
import VueNotifications from "vue-notifications";
import { ClientTable, Event } from "vue-tables-2";
import { apigClient } from "@/shared/api";
import { router } from "../../router/index";
import moment from 'moment';
import 'moment-timezone';
import DeleteConfirmModal from "./../custom-components/DeleteConfirmModal";
import InfoModal from "@/shared/Modals.vue";
import Page403 from "@/views/pages/Page403.vue";

const Spinner = () => import("../shared/Spinner");

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({ types: toastTypes });

function toast({ title, message, type, timeout, cb }) {
  return miniToastr[type](message, title, timeout, cb);
}

const notioptions = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
};

Vue.use(VueNotifications, notioptions);
Vue.use(ClientTable);

let columns = ["formName", "formCode", "formType", "postedAt", "action"];

let headings = {
  action: "",
  formName: "Form Name",
  formCode: "Form Code",
  formType: "Form Type",
  postedAt: "Last Updated"
};
let sortable = ["formName"];

//Export component
export default {
  name: "FormBuilders",
  components: {
    ClientTable,
    Spinner,
    DeleteConfirmModal,
    InfoModal,
    Page403
  },
  data: function() {
    let loginUserInfo = JSON.parse(localStorage.getItem("loginUserInfo"));
    let userTimezone = loginUserInfo.db.timezone || 'Asia/Bangkok';
    return {
      loginUserInfo: loginUserInfo,
      permission: {
        permissionBaseName: null,
        permissionBaseNameCapabilities: null,
        capabilities: {
          View: false,
          Edit: false,
          Delete: false,
          Create: false,
        }
      },
      showPage403: false,
      userTimezone : userTimezone,
      companyId: '',
      isLoading: true,
      columns: columns,
      data: [],
      options: {
        headings: headings,
        sortable: sortable,
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort"
        },
        pagination: {
          chunk: 5,
          edge: false,
          nav: "scroll"
        }
      },
      formType: "Form",
      formName: "Form Builder List",
      formRouteNew: "/components/form-builder/new",
      formRouteEdit: "/components/form-builder/edit",
      useVuex: false,
      theme: "bootstrap4",
      template: "default",

      deleteModal:{
        modalTitle: 'Delete Form',
        modalMsg: '',
        loginUserRoleName: loginUserInfo.db.roleName,
        deleteAction: '',
      },
      id: null,
      title: null,
      object_id: null,

      //Use for info modal
      infoModalTitle: null,
      infoModalOpen: false,
      infoModalBody: null,
      infoModalOkVariant: "success"
    };
  },
  methods: {
    getPermission(){
      let that = this;
      const userPermissionsBasedOnEntity = that.loginUserInfo.db.userPermissionsBasedOnEntity;
      if(this.$route.meta && userPermissionsBasedOnEntity){
        that.permission.permissionBaseName = this.$route.meta.permissionBaseName;
        let userPermissionBasedOnEntity = userPermissionsBasedOnEntity.find(p => p.permissionBaseName === this.$route.meta.permissionBaseName);
        if(userPermissionBasedOnEntity){
          that.permission.permissionBaseNameCapabilities = userPermissionBasedOnEntity.capabilities;
          that.permission.permissionBaseNameCapabilities.forEach(capability=>{
            that.permission.capabilities[capability.label] = capability.value
          });
        }
      } else{
        router.push('/no-permission-given');
      }
      console.log('permission: ' , that.permission);
    },
    convertDateTime: function(tmp, isTime) {
      let time = "";
      let a = new Date(tmp * 1000);
      let months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ];
      let year = a.getFullYear();
      let month = months[a.getMonth()];
      let date = a.getDate();
      let hour = a.getHours();
      let min = a.getMinutes();
      let sec = a.getSeconds();
      if (isTime) {
        time =
          date + " " + month + " " + year + " " + hour + ":" + min + ":" + sec;
      } else {
        time = date + " " + month + " " + year;
      }
      return time;
    },
    openDeleteModal: function(index) {
      let that = this;
      that.deleteModal.deleteAction='';
      that.id = that.data[index].fid;
      that.object_id = index;
      that.title = that.data[index].formName;
      that.deleteModal.modalMsg="Delete the Form '" + that.title  + "' ?";
      that.$refs.deleteConfirmModal.openModal();
    },
    openEditPage: function(index) {
      this.id = this.data[index].fid;
      router.push(this.formRouteEdit + this.id);
    },
    openPreview: function(index) {
      this.id = this.data[index].fid;
      window.open("/fb-display/" + this.id, "_blank");
    },
    openHistory: function(index) {
      this.id = this.data[index].fid;
      router.push("/components/form-builder/history/" + this.id);
    },
    openResults: function(index) {
      this.id = this.data[index].fid;
      router.push("/components/form-builder/result/" + this.id);
    },
    openNew: function() {
      router.push(this.formRouteNew);
    },
    getDeleteAction(data){
      let that = this;
      console.log(data);
      if(data && data.deleteAction){
        that.deleteModal.deleteAction=data.deleteAction;
        that.deleteCustomForm();
      }
    },
    changeInfoModalContent(status = null, title = null, message = null) {
      let that = this;
      that.$refs.infoModal.status = status ? status : that.$refs.infoModal.status;
      that.$refs.infoModal.title = title ? title : that.$refs.infoModal.title;
      that.$refs.infoModal.message = message ? message : that.$refs.infoModal.message;
    },
    deleteCustomForm: function() {
      let that = this;
      that.$refs.infoModal.openModal();
      that.changeInfoModalContent(
        "loading",
        "Processing...",
        (that.deleteModal.deleteAction=='MARK-AS-DELETED') ? "Deleting the Form ("+ that.title +")" :
        "Deleting the Form ("+ that.title +") permenently"
      );
      if(that.deleteModal.deleteAction=='MARK-AS-DELETED'){
        that.markFormAsDeleted(that);
      } else{
        let method = "DELETE";
        let pathTemplate = "/formBuilder/delete/" + that.id;
        let additionalParams = {};
        let pathParams = {};
        apigClient
          .invokeApi(pathParams, pathTemplate, method, additionalParams)
          .then(function(result) {
            if(result.data.status){
              console.log('delete form id: ' + that.id);
              that.changeInfoModalContent(
                "success",
                "Deleted success!",
                "The Form has been deleted"
              );
              setTimeout(that.$refs.infoModal.closeModal(), 1500);
              that.showSuccessMsg();
              that.loadAndUpdateTableListAfterItemDelete(that);
            } else{
              console.log('Error From API Endpoint: ' + result.data.message);
              that.changeInfoModalContent(
                "error",
                "Error Occured!",
                "Error From API Endpoint: " + result.data.message
              );
            }
          })
          .catch(function(error) {
            console.log("Error From API Endpoint: " + error.message);
            that.changeInfoModalContent(
              "error",
              "Error Occured!",
              "Error From API Endpoint: " + error.message
            );
          });
      }
    },
    markFormAsDeleted: (that) => {
      let method = 'PUT';
      let pathTemplate =  '/formBuilder/'+that.id+'/mark-as-deleted';
      let additionalParams ={};
      let pathParams = {};
      let body ={
        updateBy:that.loginUserInfo.login_username
      }
      apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams,body)
      .then(function(result){
        if(result.data.status){
          console.log(result);
          that.changeInfoModalContent(
            "success",
            "Deleted success!",
            "The Form data has been deleted"
          );
          setTimeout(that.$refs.infoModal.closeModal(), 1500);
          that.showSuccessMsg();
          that.loadAndUpdateTableListAfterItemDelete(that);
        }else{
          console.log('Error From API Endpoint: ' + result.data.message);
          that.changeInfoModalContent(
            "error",
            "Error Occured!",
            "Error From API Endpoint: " + result.data.message
          );
        }
      }).catch( function(error){
        that.changeInfoModalContent(
          "error",
          "Error Occured!",
          "Error From API Endpoint: " + error.message
        );
      });
    },
    loadAndUpdateTableListAfterItemDelete: function(that) {
      Vue.delete(that.data, that.object_id);
    },
    initializeInfoModal: function(modalOpen, title, body, okvariant, that) {
      that.infoModalOpen = modalOpen;
      that.infoModalTitle = title;
      that.infoModalBody = body;
      that.infoModalOkVariant = okvariant;
    },
    checkRoute: function(routePath) {
      if (routePath.indexOf("formBuilder") > -1) {
        this.formType = "Form";
        this.formName = "Form Builder List";
        this.formRouteNew = "/components/form-builder/new";
        this.formRouteEdit = "/components/form-builder/edit/";
      } else if (routePath.indexOf("codeBuilder") > -1) {
        this.formType = "Code";
        this.formName = "Code Form Builder List";
        this.formRouteNew = "/components/code-builder/new";
        this.formRouteEdit = "/components/code-builder/edit/";
      } else if (routePath.indexOf("imageBuilder") > -1) {
        this.formType = "Image";
        this.formName = "Image Form Builder List";
        this.formRouteNew = "/components/image-builder/new";
        this.formRouteEdit = "/components/image-builder/edit/";
      }
    },
    loadCustomForms: function() {
      let method = "GET";
      let pathTemplate = "/formBuilder";
      var additionalParams = {
        queryParams: {
          params: JSON.stringify({
            table: "form_builder",
            fields: ["id, formName, formCode, formType, updatedAt, createdAt, updatedBy, createdBy"],
            filter: [
              {
                fieldname: "formType",
                comparisonOperator: "=",
                value: this.formType
              },
              {
                fieldname: "companyId",
                comparisonOperator: "=",
                value: this.companyId
              },
              {
                fieldname: "isDeleted",
                comparisonOperator: "=",
                value: false
              },
            ]
          })
        }	        
      }
      let pathParams = {};
      let that = this;
      apigClient
        .invokeApi(pathParams, pathTemplate, method, additionalParams)
        .then(function(result) {
          let response = result.data;
          if (response.status) {
            let data = response.data.map((elem, index) => {
              elem.fid = elem.id;
              elem.formName = elem.formName;
              elem.formType = elem.formType;
              elem.formCode = elem.formCode;
              elem.postedAt = elem.updatedAt !== undefined ? moment(moment.unix(elem.updatedAt)).tz(that.userTimezone).format('YYYY-MM-DD HH:mm') : moment(moment.unix(elem.createdAt)).tz(that.userTimezone).format('YYYY-MM-DD HH:mm');
              elem.postedBy = elem.updatedBy !== undefined ? elem.updatedBy : elem.createdBy;
              elem.id = index;
              return elem;
            });
            that.data = [...data];
            that.isLoading = false;
          } else {
            that.showErrorMsg({ message: response.message });
            that.isLoading = false;
          }
        })
        .catch(function(error) {
          that.showErrorMsg({ message: error.message });
          that.isLoading = false;
        });
    }
  },
  mounted: function() {
    this.getPermission();
    if(!this.permission.capabilities.View){
      this.showPage403 = true;
      return;
    }
    const user = JSON.parse(localStorage.getItem('loginUserInfo'));
    this.companyId = (user.db.company.id == null || user.db.company.id == undefined || user.db.company.id == 'NULL') ? '' : user.db.company.id;
    this.checkRoute(this.$route.name);
    this.loadCustomForms();
  },
  watch: {
    $route(to, from) {
      this.checkRoute(to.name);
      this.isLoading = true;
      this.loadCustomForms();
    },
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: "Operation successfull!",
      message: "The form has been deleted"
    },
    showInfoMsg: {
      type: VueNotifications.types.info,
      title: "Hey you",
      message: "Here is some info for you"
    },
    showWarnMsg: {
      type: VueNotifications.types.warn,
      title: "Wow, man",
      message: "That's the kind of warning"
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Something goes wrong"
    }
  }
};
</script>

<style lang="scss">
#formListTable {
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }
  .VueTables__search-field input {
    margin-left: 0.25rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .action {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.custom-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.btn-secondary {
  background-color: none;
}
.modal-dialog {
  color: black;
}
.container-fluid {
  margin: 0 !important;
  padding: 0 !important;
}
.breadcrumb {
  margin-bottom: 0;
  border-bottom: 0;
}
</style>